import createIcon from '../../createIcon';

/**
 * @component @name SentimentVerySatisfied
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuOTkgMkM2LjQ3IDIgMiA2LjQ3IDIgMTJDMiAxNy41MyA2LjQ3IDIyIDExLjk5IDIyQzE3LjUxIDIyIDIyIDE3LjUzIDIyIDEyQzIyIDYuNDcgMTcuNTIgMiAxMS45OSAyWk0xMiAyMEM3LjU4IDIwIDQgMTYuNDIgNCAxMkM0IDcuNTggNy41OCA0IDEyIDRDMTYuNDIgNCAyMCA3LjU4IDIwIDEyQzIwIDE2LjQyIDE2LjQyIDIwIDEyIDIwWk0xMyA5Ljk0TDE0LjA2IDExTDE1LjEyIDkuOTRMMTYuMTggMTFMMTcuMjQgOS45NEwxNS4xMiA3LjgyTDEzIDkuOTRaTTguODggOS45NEw5Ljk0IDExTDExIDkuOTRMOC44OCA3LjgyTDYuNzYgOS45NEw3LjgyIDExTDguODggOS45NFpNMTIgMTcuNUMxNC4zMyAxNy41IDE2LjMxIDE2LjA0IDE3LjExIDE0SDYuODlDNy42OSAxNi4wNCA5LjY3IDE3LjUgMTIgMTcuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SentimentVerySatisfied = createIcon('SentimentVerySatisfied', [
  [
    'path',
    {
      d: 'M11.99 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 11.99 22C17.51 22 22 17.53 22 12C22 6.47 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM13 9.94L14.06 11L15.12 9.94L16.18 11L17.24 9.94L15.12 7.82L13 9.94ZM8.88 9.94L9.94 11L11 9.94L8.88 7.82L6.76 9.94L7.82 11L8.88 9.94ZM12 17.5C14.33 17.5 16.31 16.04 17.11 14H6.89C7.69 16.04 9.67 17.5 12 17.5Z',
      key: 'd88ohg',
    },
  ],
]);

export default SentimentVerySatisfied;
